import React, { useEffect, useState } from 'react';
import { applyOfflineUpdate, hasOfflineUpdate } from '../services/offlineShell';
import { Button, Card } from './ui';

export default function AppUpdateSettings() {
  const [available, setAvailable] = useState(hasOfflineUpdate());
  useEffect(() => {
    const changed = () => setAvailable(hasOfflineUpdate());
    window.addEventListener('sonata-offline-update', changed);
    return () => window.removeEventListener('sonata-offline-update', changed);
  }, []);
  if (!available) return null;
  return <Card className="p-6"><div className="flex flex-wrap items-center justify-between gap-3"><div><h3 className="font-semibold text-gray-900">App update available</h3><p className="text-sm text-gray-500 mt-1">Reload when you’re ready. Finish any open forms first.</p></div><Button variant="outline" onClick={applyOfflineUpdate}>Update app</Button></div></Card>;
}
